// eslint-disable-next-line
export const docsLinks: { [index: string]: any } = {
  generic: {
    mcp: "https://docs.shakebugs.com/docs/mcp/",
    restApi: "https://docs.shakebugs.com/docs/rest-api/",
  },
  iOS: {
    installation: "https://docs.shakebugs.com/docs/ios/install/spm/",
    import: "https://docs.shakebugs.com/docs/ios/import-from-instabug",
    registerAppUser: "https://docs.shakebugs.com/docs/ios/users/register-user/",
    addTicketMetadata: "https://www.shakebugs.com/docs/ios/configuration-and-data/ticket-metadata/",
    invoke: "https://docs.shakebugs.com/docs/ios/user-feedback/invoke/",
    enableLogs: "https://docs.shakebugs.com/docs/ios/configuration-and-data/activity-history",
    deobfuscation: "https://docs.shakebugs.com/docs/ios/crash-reports/symbolicate/",
    enableCrashReporting: "https://docs.shakebugs.com/docs/ios/crash-reports/enable/",
    testCrashReports: "https://docs.shakebugs.com/docs/ios/crash-reports/test-it-out/",
    addUserMetadata: "https://www.shakebugs.com/docs/ios/users/update-user-metadata/",
    autoAttach: "https://docs.shakebugs.com/docs/ios/configuration-and-data/auto-attach-files/",
    networkTraffic: "https://docs.shakebugs.com/docs/ios/configuration-and-data/activity-history/#network-traffic",
    releases: "https://docs.shakebugs.com/docs/ios/releases/overview/",
    feedback: "https://docs.shakebugs.com/docs/ios/user-feedback/overview/",
    crashes: "https://docs.shakebugs.com/docs/ios/crash-reports/overview/",
    users: "https://docs.shakebugs.com/docs/ios/users/overview/",
  },
  Android: {
    installation: "https://docs.shakebugs.com/docs/android/installation/",
    import: "https://docs.shakebugs.com/docs/android/import-from-instabug",
    registerAppUser: "https://docs.shakebugs.com/docs/android/users/register-user/",
    addTicketMetadata: "https://www.shakebugs.com/docs/android/configuration-and-data/ticket-metadata/",
    invoke: "https://docs.shakebugs.com/docs/android/user-feedback/invoke/",
    activityHistory: "https://docs.shakebugs.com/docs/android/configuration-and-data/activity-history",
    deobfuscation: "https://docs.shakebugs.com/docs/android/crash-reports/deobfuscation/",
    enableCrashReporting: "https://docs.shakebugs.com/docs/android/crash-reports/enable/",
    testCrashReports: "https://docs.shakebugs.com/docs/android/crash-reports/test-it-out/",
    addUserMetadata: "https://www.shakebugs.com/docs/android/users/update-user-metadata/",
    autoAttach: "https://docs.shakebugs.com/docs/android/configuration-and-data/auto-attach-files/",
    networkTraffic: "https://docs.shakebugs.com/docs/android/configuration-and-data/activity-history/#network-traffic",
    releases: "https://docs.shakebugs.com/docs/android/releases/overview/",
    feedback: "https://docs.shakebugs.com/docs/android/user-feedback/overview/",
    crashes: "https://docs.shakebugs.com/docs/android/crash-reports/overview/",
    users: "https://docs.shakebugs.com/docs/android/users/overview/",
  },
  ReactNative: {
    installation: "https://docs.shakebugs.com/docs/react/install/npm/",
    import: "https://docs.shakebugs.com/docs/react/import-from-instabug",
    registerAppUser: "https://docs.shakebugs.com/docs/react/users/register-user/",
    addTicketMetadata: "https://www.shakebugs.com/docs/react/configuration-and-data/ticket-metadata/",
    invoke: "https://docs.shakebugs.com/docs/react/user-feedback/invoke/",
    enableLogs: "https://docs.shakebugs.com/docs/react/configuration-and-data/activity-history",
    deobfuscation: "https://docs.shakebugs.com/docs/react/crash-reports/deobfuscation/",
    addUserMetadata: "https://www.shakebugs.com/docs/react/users/update-user-metadata/",
    autoAttach: "https://docs.shakebugs.com/docs/react/configuration-and-data/auto-attach-files/",
    networkTraffic: "https://docs.shakebugs.com/docs/react/configuration-and-data/activity-history/#network-traffic",
    releases: "https://docs.shakebugs.com/docs/react/releases/overview/",
    feedback: "https://docs.shakebugs.com/docs/react/user-feedback/overview/",
    crashes: "https://feedback.shakebugs.com/feature-requests/p/react-native-sdk-crash-reports",
    users: "https://docs.shakebugs.com/docs/react/users/overview/",
  },
  Flutter: {
    installation: "https://docs.shakebugs.com/docs/flutter/installation/",
    import: "https://docs.shakebugs.com/docs/flutter/import-from-instabug",
    registerAppUser: "https://docs.shakebugs.com/docs/flutter/users/register-user/",
    addTicketMetadata: "https://www.shakebugs.com/docs/flutter/configuration-and-data/ticket-metadata/",
    invoke: "https://docs.shakebugs.com/docs/flutter/user-feedback/invoke/",
    enableLogs: "https://docs.shakebugs.com/docs/flutter/configuration-and-data/activity-history",
    deobfuscation: "https://docs.shakebugs.com/docs/flutter/crash-reports/deobfuscation/",
    addUserMetadata: "https://www.shakebugs.com/docs/flutter/users/update-user-metadata/",
    autoAttach: "https://docs.shakebugs.com/docs/flutter/configuration-and-data/auto-attach-files/",
    networkTraffic: "https://docs.shakebugs.com/docs/flutter/configuration-and-data/activity-history/#network-traffic",
    releases: "https://docs.shakebugs.com/docs/flutter/releases/overview/",
    feedback: "https://docs.shakebugs.com/docs/flutter/user-feedback/overview/",
    crashes: "https://feedback.shakebugs.com/feature-requests/p/flutter-sdk-crash-reports",
    users: "https://docs.shakebugs.com/docs/flutter/users/overview/",
  },
  Web: {
    installation: "https://docs.shakebugs.com/docs/web/install/npm/",
    import: "https://docs.shakebugs.com/docs/web/import-from-instabug",
    registerAppUser: "https://docs.shakebugs.com/docs/web/users/register-user/",
    addTicketMetadata: "https://www.shakebugs.com/docs/web/configuration-and-data/ticket-metadata/",
    invoke: "https://docs.shakebugs.com/docs/web/user-feedback/invoke/",
    enableLogs: "https://docs.shakebugs.com/docs/web/configuration-and-data/activity-history",
    deobfuscation: "https://docs.shakebugs.com/docs/web/crash-reports/deobfuscation/",
    addUserMetadata: "https://www.shakebugs.com/docs/web/users/update-user-metadata/",
    autoAttach: "https://docs.shakebugs.com/docs/web/configuration-and-data/auto-attach-files/",
    networkTraffic: "https://docs.shakebugs.com/docs/web/configuration-and-data/activity-history/#network-traffic",
    releases: "https://docs.shakebugs.com/docs/web/releases/overview/",
    feedback: "https://docs.shakebugs.com/docs/web/user-feedback/overview/",
    crashes: "https://feedback.shakebugs.com/feature-requests/p/web-sdk-crash-reports",
    users: "https://docs.shakebugs.com/docs/web/users/overview/",
  },
};

const docLink = (platform?: string) => {
  return platform ? docsLinks[platform] : "";
};

const openDocsInNewTab = (url: string) => {
  window.open(url, "_blank")?.focus();
};

export { docLink, openDocsInNewTab };
